export default __webpack_public_path__ + "static/media/open-sans-latin-700.92425c62.woff2";